import React from "react";
import "./resume.css";
import Menu from "../../components/menu/menu";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdOutlineWorkOutline, MdSchool } from "react-icons/md";
import { AiOutlineDownload } from "react-icons/ai";
import Curriculo from "../../assets/pdf/Leonardo Oliveira Souza.pdf";

const Resume = () => {
 const experiences = [
  {
    date: "jun/2025 – atual | Belo Horizonte – MG",
    title: "Desenvolvedor Full Stack Pleno | Referência Técnica",
    company: "Construsite Brasil",
    icon: <MdOutlineWorkOutline />,
    description: [
      "Desenvolvimento, refatoração e manutenção de aplicações PHP/Laravel",
      "Desenvolvimento e evolução de APIs REST, autenticação, validações e integrações com serviços externos",
      "Implementação e evolução de arquiteturas multi-tenant",
      "Desenvolvimento de filas, Jobs e processamento assíncrono",
      "Modelagem e otimização de SQL e estruturas de banco de dados",
      "Desenvolvimento frontend com React, JavaScript, jQuery e AJAX",
      "Utilização de Docker para padronização e gerenciamento de ambientes",
      "Utilização de Git para versionamento, branches, merges e colaboração",
      "Utilização de Linux, Terminal e CLI para desenvolvimento, diagnóstico e manutenção de aplicações",
      "Aplicação de Clean Code, SOLID e boas práticas de arquitetura",
      "Realização de code reviews e definição de padrões técnicos",
      "Atuação como referência técnica, apoiando o time em decisões de arquitetura e implementação",
      "Desenvolvimento de soluções com foco em performance, escalabilidade, disponibilidade e manutenibilidade",
    ],
  },

  {
    date: "out/2023 – jun/2025 | Belo Horizonte – MG",
    title: "Team Leader",
    company: "Construsite Brasil",
    icon: <MdOutlineWorkOutline />,
    description: [
      "Atuação como Team Leader com forte participação hands-on no desenvolvimento de aplicações web",
      "Conciliação de responsabilidades de liderança técnica com desenvolvimento, arquitetura e evolução da base de código",
      "Atuação como referência técnica do time, apoiando decisões de implementação e resolução de problemas",
      "Desenvolvimento, refatoração e manutenção de aplicações PHP/Laravel",
      "Criação e evolução de APIs REST e integrações com serviços externos",
      "Implementação de regras de negócio e soluções voltadas à escalabilidade e performance",
      "Desenvolvimento e otimização de consultas SQL",
      "Desenvolvimento frontend utilizando React, JavaScript, jQuery e AJAX",
      "Participação na definição de arquitetura e padrões de desenvolvimento",
      "Implementação de boas práticas como SOLID, Clean Code e separação de responsabilidades",
      "Utilização de Git, Docker e ferramentas de Terminal/Linux no fluxo de desenvolvimento",
      "Realização de code reviews e análise técnica das implementações",
      "Apoio e orientação técnica aos desenvolvedores",
      "Participação na estruturação e evolução de novos projetos e funcionalidades",
      "Desenvolvimento hands-on na maior parte das atividades, mantendo atuação direta na base de código",
    ],
  },

  {
    date: "dez/2022 – out/2023 | Belo Horizonte – MG",
    title: "Desenvolvedor Web",
    company: "Construsite Brasil",
    icon: <MdOutlineWorkOutline />,
    description: [
      "Desenvolvimento e manutenção de aplicações web com foco em backend e integrações",
      "Desenvolvimento de sistemas em PHP, com implementação de regras de negócio e validações",
      "Criação e consumo de APIs REST utilizando Laravel",
      "Integração com serviços externos e tratamento de respostas de APIs",
      "Manutenção evolutiva e corretiva em sistemas legados",
      "Implementação de melhorias estruturais visando performance e organização do código",
    ],
  },

  {
    date: "ago/2022 – dez/2022 | Belo Horizonte – MG",
    title: "Estagiário de Desenvolvimento Web PHP",
    company: "Construsite Brasil",
    icon: <MdOutlineWorkOutline />,
    description: [
      "Implementação de funcionalidades utilizando PHP conforme especificações técnicas",
      "Correção de bugs e manutenção de regras de negócio",
      "Desenvolvimento e evolução de funcionalidades completas em aplicações web",
    ],
  },

  {
    date: "fev/2022 – jun/2022",
    title: "Desenvolvedor Python",
    company: "Whobots",
    icon: <MdOutlineWorkOutline />,
    description: [
      "Desenvolvimento e manutenção de chatbots para a plataforma Telegram",
      "Implementação de funcionalidades utilizando Python",
    ],
  },
];

  return (
    <>
      <Menu url="resume" />
      <main className="resume-page">
        <div className="resume-container">
          {/* Header */}
          <section className="resume-header">
            <h1 className="resume-page-title">
              Experiência Profissionail
            </h1>
            <p className="resume-subtitle">
              Confira minha trajetória e competências desenvolvidas ao longo dos anos
            </p>
            <div className="header-divider"></div>

            {/* Botão Download */}
            <a 
              href={Curriculo} 
              download="Leonardo Souza - Currículo.pdf"
              className="btn  btn-project-primary btn-download"
              aria-label="Baixar currículo em PDF"
            >
              <AiOutlineDownload className="btn-icon" />
              Baixar Currículo
            </a>
          </section>

          {/* Timeline */}
          <section className="resume-timeline-section">
            <VerticalTimeline>
              {experiences.map((exp, index) => (
                <VerticalTimelineElement
                  key={index}
                  date={exp.date}
                  dateClassName="timeline-date"
                  icon={exp.icon}
                  iconClassName="timeline-icon"
                  contentClassName="timeline-content"
                >
                  <article className="experience-card">
                    <header className="experience-header">
                      <h3 className="experience-title">{exp.title}</h3>
                      <p className="experience-company">{exp.company}</p>
                    </header>

                    {/* Descrição */}
                    <div className="experience-description">
                      {exp.description.length > 1 ? (
                        <ul className="description-list">
                          {exp.description.map((item, idx) => (
                            <li key={idx}>{item}</li>
                          ))}
                        </ul>
                      ) : (
                        <p>{exp.description[0]}</p>
                      )}
                    </div>
                  </article>
                </VerticalTimelineElement>
              ))}
            </VerticalTimeline>
          </section>
        </div>
      </main>
    </>
  );
};

export default Resume;
